/** Private workspace URLs must never reach marketing analytics or replay. */
export function isPrivateWorkspaceUrl(value: string, base = 'https://chatsyncs.com'): boolean {
  try {
    const url = new URL(value, base)
    return url.pathname === '/team-invite' || url.pathname.startsWith('/team-invite/') || url.pathname.startsWith('/api/partner/') || url.pathname === '/offer' || url.pathname.startsWith('/offer/') || url.pathname === '/api/share-offers' || url.pathname.startsWith('/api/share-offers/') || url.hostname.startsWith('partner.') || url.pathname === '/partner' || url.pathname.startsWith('/partner/') || url.pathname === '/admin' || url.pathname.startsWith('/admin/')
  } catch { return true }
}
export function crossesWorkspaceBoundary(from: string, to: string): boolean {
  try { return new URL(from).origin === new URL(to, from).origin && isPrivateWorkspaceUrl(from) !== isPrivateWorkspaceUrl(to, from) }
  catch { return false }
}
export function publicAnalyticsEvent<T extends { url: string }>(event: T, currentUrl: string): T | null {
  return isPrivateWorkspaceUrl(currentUrl) || isPrivateWorkspaceUrl(event.url, currentUrl) ? null : event
}
/** Also reject inherited referrers/person properties from older page sessions. */
export function containsPrivateAnalyticsUrl(properties: unknown, depth = 0): boolean {
  if (!properties || typeof properties !== 'object' || depth > 3) return false
  return Object.entries(properties).some(([key, value]) =>
    (typeof value === 'string' && /url|referrer|pathname/i.test(key) && isPrivateWorkspaceUrl(value)) ||
    (typeof value === 'object' && containsPrivateAnalyticsUrl(value, depth + 1)))
}
